

<script>
  import Shimmer from "./Shimmer.svelte";

  
  export let course;
  export let issetCenter = undefined;
  export let centerId = undefined;
  export let textSize = "text-xl.5";

  //console.log("textsize",textSize);

  //font sizes
let textSizeCSS = {
    "text-xs": "text-xs",
    "text-sm": "text-sm",
    "text-base": "text-base",
    "text-lg": "text-lg",
    "text-xl": "text-xl",
    "text-2xl": "text-2xl",
    "text-3xl": "text-3xl",
    "text-4xl": "text-4xl"
};

//console.log("textsize after",textSize);

$: renderedTextSize = textSizeCSS[textSize] || "text-xl.5";


     // title case function
     function toTitleCase(str) {
      if (!str) return '';
      return str
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim()
          .replace(/\b\w/g, c => c.toUpperCase());
  }


  let loadingClass = "";
  let isHovered = false;
  let showTooltip = false;


$: loadingClass = course.loading === true ? "animate-pulse bg-pm-grey" : "";
function toggleTooltip() {
  
  showTooltip = !showTooltip;
}
function closeTooltip() {
    showTooltip = false;
  }

  // const regex = /^https?:\/\/[^/]+\/([a-zA-Z]{2}-[a-zA-Z0-9]{0,3})\//;
  const regex = /^https?:\/\/[^/]+\/([a-zA-Z]{2}(?:-[a-zA-Z0-9]{0,3})?)(\/|$)/;


  // Function to extract the substrings
function extractSubstrings(url) {
  const match = url.match(regex);
  return match ? ("/" + match[1]) : "";
}

let prefix = extractSubstrings(window.location.href)

</script>



{#if course.loading}
  <Shimmer courseSearch = {true} vertical={true}/>
{:else }
<div class=" snap-center sm:snap-align-none testmonial-card tz-0 rounded-2xl overflow-hidden relative transition-transform duration-300 w-[285px] h-[380px]">
  <a href="{course.url}" class="w-[290px] h-[380px] gtm-teacher-anchor">
  <img width="285" height="380" src="{course.user_image}" class="object-cover h-full w-full" loading="lazy" />
  <div class="absolute w-full h-full top-0 rounded-2xl block bg-gradient-to-b from-transparent via-transparent to-pm-realblack z-[100]">
    <div class="absolute bottom-0 p-3">
        <p class="w-full {renderedTextSize} font-bold text-pm-white profession mb-0">
          <!-- {course.first_name} {course.last_name} -->
          {toTitleCase(course.first_name)} {toTitleCase(course.last_name)}
      </p>
      <!-- <p class="w-full text-lg text-pm-white profession mb-0">Happiness Program, Online...</p> -->
    </div>
  </div>
  </a>
</div>

{/if}


<style>
  
  .tooltip:hover .tooltip-content{
      opacity: 1;
      z-index: 999;
      transition: z-index 100ms ;
  } 
  .tooltip-content .description p{
    color: #333 !important;
  }
   .full-address-hover{
    box-shadow: rgba(0, 0, 0, 0.45) 0px 15px 15px -15px;
   }
   
   .popup-content {
    position: absolute;
    padding: 10px;
    left: -50%;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background-color: rgb(236, 165, 90);
    border-radius: 4px;
  }
  
  </style>